import { LanguageSelect, LocaleFormat } from '@components'

import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { selectableInvoiceLanguages } from '@features/invoices/constants/selectableInvoiceLanguages'
import { syncDefaultInvoiceTextsOnLanguageChange } from '@features/invoices/utils/syncDefaultInvoiceTextsOnLanguageChange'
import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const DefaultLanguage = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem, getValues, setValue } = useFormContext<InvoiceSettingsFormSchema>()

  const handleLanguageSelect = useCallback(
    (newLanguage?: LocaleFormat, previousLanguage?: LocaleFormat) => {
      syncDefaultInvoiceTextsOnLanguageChange({ getValues, newLanguage, previousLanguage, setValue, t })
      trackInvoicingSettings('Language dropdown selected', { language: newLanguage })
    },
    [getValues, setValue, t, trackInvoicingSettings],
  )

  return (
    <FormItem
      label={t('settings.organization.external_invoice.general.default_language.label')}
      name="language"
      render={({ field: { value, onChange, ...rest } }) => (
        <LanguageSelect
          {...rest}
          languages={selectableInvoiceLanguages}
          onSelect={(newLanguage) => {
            onChange(newLanguage)
            handleLanguageSelect(newLanguage, value)
          }}
          selectedId={value}
          withSearch={false}
        />
      )}
    />
  )
}
